import React, {Component} from "react";
import FaqItem from "./FaqItem";
import {FaqItemEntiy} from "../../data/entities/FaqItemEntiy";

export default class FaqList extends Component {
    private faqItems: FaqItemEntiy[] = [
        {
            question: "What is the Cloud Gaming beta?",
            answer: <>The Cloud Gaming beta is available for all current US subscribers, and offers you access to select Ubisoft games on the Luna and Stadia cloud gaming platforms. You can play on compatible devices using either or both Stadia and Luna. We are launching this beta to bring Ubisoft+ to more platforms and give you the freedom to choose how you play. We welcome your feedback in our journey to bring you the best gaming experience.</>,
        },
        {
            question: "What are Stadia and Luna?",
            answer: <>Stadia is a cloud gaming platform and Luna is a cloud gaming service through which you can play games on multiple compatible devices.</>,
        },
        {
            question: "Where can I find my Luna code?",
            answer: <>
                After requesting your code, you will receive your code by email, or you can find it in your&nbsp;
                <a href="https://account.ubisoft.com/beta-access" target="_blank" rel="noopener noreferrer">
                    Ubisoft Account Management
                </a>.
            </>,
        },
        {
            question: "After clicking \"Request code\", my code is still processing. What can I do?",
            answer: <>
                We are currently processing your request. If there is a delay, please refresh your page. If the problem persists, please contact&nbsp;
                <a href="https://support.ubisoft.com/" target="_blank" rel="noopener noreferrer">
                    Customer Support
                </a>.
            </>,
        },
        {
            question: "What should I do after having filled the survey on Luna?",
            answer: <>
                After submitting the survey, please wait for your Luna early access invitation. The invitation will include a link that will grant you access to Luna. Once you receive the invitation, the link in your Luna invitation must be accepted within 7 days. If this delay has passed and the link has expired, please contact the&nbsp;
                <a href="https://www.amazon.com/gp/help/customer/display.html" target="_blank" rel="noopener noreferrer">
                    Amazon Customer Support
                </a>.
            </>,
        },
        {
            question: "Where is Luna available?",
            answer: <>Luna is supported across mainland US. We currently do not support Hawaii, Alaska, and U.S. territories.</>,
        },
        {
            question: "How do I link my Ubisoft account to Luna?",
            answer: <>
                Once you have received your Luna early access invitation, head over to the&nbsp;
                <a href="https://www.amazon.com/luna/" target="_blank" rel="noopener noreferrer">
                    Luna website
                </a>
                &nbsp;to link your Ubisoft account.
            </>,
        },
        {
            question: "What happens at the end of the beta?",
            answer: <>Before the end of the beta, you will receive information from Ubisoft+ about how to keep your access to Luna and Stadia. If you prefer playing on PC, you will be able to keep your current subscription plan and continue discovering our worlds!</>,
        },
        {
            question: "How do I unlink my account from Luna? What happens when I unlink my accounts?",
            answer: <>
                You can unlink your Ubisoft account by going to your&nbsp;
                <a href="https://www.amazon.com/luna/settings" target="_blank" rel="noopener noreferrer">
                    Luna settings
                </a>
                . Note that if you unlink your accounts, you will not be able to access the Ubisoft+ beta on Luna unless you re-link your accounts again.
            </>,
        },
        {
            question: "What data is shared between Luna, Stadia and Ubisoft?",
            answer: <>
                We will only share your Ubisoft user ID and username with Luna and Stadia. To know more about the processing of your personal data please read the&nbsp;
                <a href="https://legal.ubi.com/privacypolicy/" target="_blank" rel="noopener noreferrer">
                    Ubisoft Privacy Policy
                </a>
                ,&nbsp;
                <a href="https://www.amazon.com/gp/help/customer/display.html" target="_blank" rel="noopener noreferrer">
                    Amazon Privacy Policy
                </a>
                , and&nbsp;
                <a href="https://stadia.google.com/privacy" target="_blank" rel="noopener noreferrer">
                    Stadia Privacy Policy
                </a>
            .</>,
        },
    ];

    render(): JSX.Element {
        return (
            <section className="anywhereTab__faq" id="faq-section">

                <h3 className="section-title">Frequently Asked Questions</h3>

                <div className="anywhereTab__faq__container">

                    {
                        this.faqItems.map((faq, index) => (
                            <FaqItem
                                key={index}
                                question={faq.question}
                                answer={faq.answer}
                                index={index}
                            />
                        ))
                    }

                </div>

            </section>
        );
    }
}